export default {
  name: "English",
  pageTitles: {
    home: "Académie AETHERIS — Clarity in Service of Your Sovereignty",
    kit: "Premium Digital Kit — Académie AETHERIS",
    about: "About — Académie AETHERIS",
    services: "The Method — Académie AETHERIS",
    bilan: "Free Sovereignty Diagnostic — Académie AETHERIS",
    merci: "Thank You — Académie AETHERIS",
  },
  pageDescs: {
    home: "Académie AETHERIS — Reveal the secret architecture of your life. Triple Fusion™ Method: Numerology, Feng Shui and IFÀ for leaders and entrepreneurs.",
    kit: "Premium Digital Kit — 67€: the book “Before You Become”, the 12 Sovereign Decrees, the Sovereign Workbook and the Triple Fusion™ grids. Immediate delivery.",
    about: "Rodrigue CASSILDÉ, Life Architect and founder of Académie AETHERIS. The Triple Fusion™ method born from 20 years of research and fieldwork.",
    services: "Discover Académie AETHERIS offerings: free Diagnostic, 67€ Digital Kit, personalized Analyses and elite Triple Fusion™ Coaching.",
    bilan: "Book your FREE Sovereignty Diagnostic with Académie AETHERIS. Identify what is blocking your trajectory within 24 hours.",
    merci: "Thank you for your order — download your 6 Triple Fusion™ tools.",
  },
  nav: { home: "Home", method: "The Method", kit: "Digital Kit", about: "About", bilan: "Free Assessment" },
  hero: {
    eyebrow: "Académie AETHERIS — Life Architecture",
    titleLines: ["Clarity in Service", "of Your Sovereignty."],
    sub: "Stop enduring your destiny. Access the millennial precision of the IFÀ, Lo Shu and Pythagoras fusion to lift your blockages and build your own empire.",
    ctaPrimary: "Request your free Sovereignty Diagnostic",
    ctaSecondary: "Discover the Method",
  },
  marquee: ["Triple Fusion™", "Vibratory Numerology", "Tibetan Feng Shui", "Life Architecture", "Lo Shu Grid", "Total Sovereignty", "Karmic Debts"],
  method: {
    label: "The Triple Fusion™ Method",
    title: "Three millennial wisdoms, one trajectory of power.",
    quote: "PYTHAGORAS decoded numbers. Lo Shu decoded space. IFÀ — UNESCO Intangible Heritage — decoded destiny. The Triple Fusion™ is the first method to unite these three wisdoms.",
    cards: [
      { num: "01", name: "IFÀ", tag: "Memory", title: "The memory of your lineage", desc: "Ancestral wisdom listed as UNESCO Intangible Heritage. IFÀ reveals lineage debts and inherited patterns repeating in your life — so you can finally defuse them." },
      { num: "02", name: "Lo Shu", tag: "Space", title: "The harmony of your environment", desc: "The Lo Shu grid, heart of Tibetan Feng Shui, maps your living space so that every direction works for you, never against you." },
      { num: "03", name: "Pythagoras", tag: "Number", title: "The vibration of your identity", desc: "Your name and date of birth form a unique vibratory signature. Pythagoras decodes it for sovereign decisions, taken at the right moment." },
    ],
  },
  pathways: {
    label: "The Pathways",
    title: "Choose the degree of your metamorphosis.",
    offers: [
      { id: "diagnostic", name: "Sovereignty Diagnostic", price: "Free", features: ["Your birth matrix reading", "Identification of your priority locks", "30-minute restitution call"], cta: "Book my diagnostic", to: "bilan" },
      { id: "analyse", name: "Precision Analysis", price: "149€", features: ["Complete personal Lo Shu grid", "Detailed vibratory report", "Targeted Feng Shui recommendations"], cta: "Order the analysis", to: "bilan" },
      { id: "pack", name: "Quantum Renaissance Pack", price: "250€", badge: "Most popular", features: ["Includes the full Precision Analysis", "Karmic debts clearing", "90-day reconquest protocol"], cta: "Choose Renaissance", to: "bilan" },
      { id: "elite", name: "Elite Coaching — Metamorphosis", price: "1,950€", features: ["Individual Triple Fusion™ follow-up", "Complete Life Architecture", "Access to the private AETHERIS Circle"], cta: "Apply", to: "bilan" },
    ],
  },
  kitHome: {
    label: "Premium Digital Kit",
    title: "The book they should have given you at birth.",
    desc: "An identity decoder: your repeating patterns, the locks of your lineage, your numerical cycles — and the concrete keys to deactivate them, one by one.",
    price: "67€",
    cta: "Discover the Kit",
  },
  founder: {
    label: "The Founder",
    name: "Rodrigue Cassildé",
    bio: "Authority in Life Architecture, Vibratory Numerology and Triple Fusion™ Feng Shui. For 15 years, he has been guiding leaders, entrepreneurs and empire builders toward Total Sovereignty.",
    cta: "Discover his journey",
  },
  finalCta: { title: "Your empire begins with a diagnostic.", cta: "Request your free Sovereignty Diagnostic" },
  kit: {
    badges: ["Immediate delivery", "Secure payment — Stripe", "Lifetime access"],
    label: "Premium Digital Kit",
    title: "The 6 founding tools of your reconquest.",
    sub: "A complete system — book, decrees, workbook, grids and letter — to decode who you are and take back control.",
    toolsLabel: "The Contents",
    toolsTitle: "6 sovereign tools, designed to be used.",
    tools: [
      { name: "BEFORE YOU BECOME", tag: "The founding book" },
      { name: "The 12 Sovereign Decrees", tag: "Alignment laws" },
      { name: "The Sovereign Workbook", tag: "Operational journal — 90 days" },
      { name: "The Triple Fusion™ Guided Grid", tag: "Personal cartography" },
      { name: "The Lo Shu Directions Map", tag: "Space compass" },
      { name: "The Founder's Letter", tag: "Personal message from Rodrigue Cassildé" },
    ],
    bookLabel: "The Founding Book",
    bookTitle: "Before You Become — the book you should have received at birth.",
    bookCopy: [
      "No one handed you the instruction manual. Not school, not your family, not society. You learned to function — never to decode yourself.",
      "This book is an identity decoder. It crosses the wisdom of IFÀ, the Lo Shu grid and Pythagoras' numbers to reveal what has always been written: your cycles, your locks, your lines of force.",
    ],
    bullets: [
      "Your repeating patterns — and why they always come back",
      "The locks of your lineage — and how to deactivate them",
      "Your personal numerical cycles — to decide at the right moment",
      "Your Triple Fusion™ cartography — your sovereign starting point",
    ],
    ctaTitle: "Your reconquest starts now.",
    ctaSub: "A one-time investment of 67€ to receive the 6 founding tools of the Triple Fusion™ method.",
    buy: "I order my Kit — 67€",
    note: "Delivery by email immediately after payment.",
    afterLink: "Already ordered? Access your downloads",
  },
  about: {
    label: "About",
    title: "The architect behind the method.",
    bioLabel: "The Founder",
    bio: [
      "Rodrigue Cassildé — authority in Life Architecture, Vibratory Numerology and Triple Fusion™ Feng Shui.",
      "For 15 years, he has guided leaders, entrepreneurs and empire builders toward Total Sovereignty. His conviction: no one should endure a destiny they have not decoded.",
      "Académie AETHERIS was born of this conviction — a house where three millennial wisdoms become a single trajectory of power.",
    ],
    quote: "PYTHAGORAS decoded numbers. Lo Shu decoded space. IFÀ — UNESCO Intangible Heritage — decoded destiny. The Triple Fusion™ is the first method to unite these three wisdoms.",
    valuesLabel: "Cardinal Values",
    valuesTitle: "What is never negotiated.",
    values: [
      { num: "01", name: "Excellence", desc: "No compromise. Every analysis, every protocol, every word is delivered with the same rigour — your trajectory deserves the best of the three wisdoms." },
      { num: "02", name: "Sovereignty", desc: "Master of your destiny. We do not create dependency: we hand over the keys so you never endure again." },
      { num: "03", name: "Discretion", desc: "Elite, confidential. Your matrix, your locks, your decisions — everything said here stays here." },
    ],
    legalLabel: "Legal Structure",
    legal: "Académie AETHERIS operates under Synergie VITA Holding (SVH), SAS with €500 capital, registered at RCS Fort-de-France under SIREN 108849241.",
    ctaTitle: "Ready to meet your matrix?",
    cta: "Request your free Sovereignty Diagnostic",
  },
  services: {
    label: "Our Services",
    title: "One path for every degree of Sovereignty.",
    sub: "From the first diagnostic to elite mentorship, each path is a step. Choose yours.",
    offers: [
      { id: "diagnostic", name: "Sovereignty Diagnostic", price: "Free", desc: "The starting point. 30 minutes to read your matrix and name what blocks you.", features: ["Your birth matrix reading", "Identification of your priority locks", "30-minute restitution call"], cta: "Book my diagnostic", to: "bilan" },
      { id: "kit", name: "Premium Digital Kit", price: "67€", desc: "The 6 founding tools of the Triple Fusion™ method, delivered immediately.", features: ["The book “Before You Become”", "The 12 Sovereign Decrees", "The Sovereign Workbook — 90 days", "The Triple Fusion™ Guided Grid"], cta: "Order the Kit", to: "kit" },
      { id: "analyse", name: "Precision Analysis", price: "149€", desc: "Your complete vibratory cartography.", features: ["Complete personal Lo Shu grid", "Detailed vibratory report", "Targeted Feng Shui recommendations"], cta: "Order the analysis", to: "bilan" },
      { id: "pack", name: "Quantum Renaissance Pack", price: "250€", badge: "Most popular", desc: "The analysis, the clearing, the protocol.", features: ["Includes the full Precision Analysis", "Karmic debts clearing", "90-day reconquest protocol"], cta: "Choose Renaissance", to: "bilan" },
      { id: "elite", name: "Elite Coaching — Metamorphosis", price: "1,950€", desc: "Three months of private mentorship with Rodrigue Cassildé.", features: ["Individual Triple Fusion™ follow-up", "Complete Life Architecture", "Access to the private AETHERIS Circle"], cta: "Apply", to: "bilan" },
    ],
  },
  bilan: {
    label: "Free Sovereignty Diagnostic — 30 minutes",
    title: "You feel something is blocking your life — but you don't know what?",
    sub: "In 30 minutes, we read your matrix, identify your priority locks and hand you a concrete action plan. No commitment.",
    benefitsLabel: "What you walk away with",
    benefits: [
      "A clear reading of your birth matrix",
      "Identification of your priority locks",
      "Your first Lo Shu directions",
      "A concrete, immediate action plan",
    ],
    testimonialsLabel: "They took the leap",
    testimonials: [
      { text: "In one call, Rodrigue named what three years of therapy had only brushed against. My 90-day protocol changed everything.", name: "Claire M.", role: "Entrepreneur" },
      { text: "The Precision Analysis read me like an open book. I finally understood why the same patterns kept coming back — and how to end them.", name: "Julien R.", role: "Executive" },
      { text: "I was skeptical. Then the Lo Shu grid explained my home, my choices, my blocks. Nothing has been the same since.", name: "Sofia D.", role: "Founder" },
    ],
    form: {
      title: "Book your slot",
      firstNames: "First names",
      lastName: "Last name",
      maidenName: "Maiden name (optional)",
      birthDate: "Date of birth",
      sex: "Sex",
      female: "Female",
      male: "Male",
      email: "Email",
      submit: "Request my free Diagnostic",
      sending: "Sending…",
      success: "Your request has been received. Rodrigue will contact you within 24 hours. In the meantime, you can also book a slot directly:",
      calendlyButton: "Book my follow-up call (30 min)",
      error: "Something went wrong. Please try again in a moment.",
    },
    quote: { text: "You are not stuck. You are simply running on the wrong instruction manual.", author: "Rodrigue Cassildé" },
  },
  merci: {
    label: "Order Confirmed",
    title: "Your Kit is on its way.",
    sub: "Your 6 tools are on their way to your inbox. You can also download them immediately below.",
    frOnlyNote: "",
    downloadsLabel: "Your downloads",
    note: "Keep these links safe — lifetime access.",
    backHome: "Back to home",
  },
  footer: {
    tagline: "Life Architecture — IFÀ ◆ Lo Shu ◆ Pythagoras",
    navTitle: "Navigation",
    langTitle: "Language",
    svh: "Académie AETHERIS — Synergie VITA Holding (SVH), SAS with €500 capital — RCS Fort-de-France — SIREN 108849241",
    rights: "© 2026 Académie AETHERIS. All rights reserved.",
  },
};
